import { type Colors, type Icon } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { DUE_STATES, DueDateState, dueDateState } from 'modules/notifications/lib/DueDateState'

interface Props {
  state: DueDateState | null
  dueTextColor: Colors
  dueIconColor: Colors
  dueIcon: React.ComponentProps<typeof Icon.Medium>['icon']
  dueDaysBetweenToday: number | undefined
}

export function dueDateStateData(dueDate?: moment.Moment): Props {
  const state = dueDate ? dueDateState(dueDate) : null
  const dueTextColor = state == DUE_STATES.overdue ? 'radicalRed1500' : 'grey800'
  const dueIconColor = state == DUE_STATES.overdue ? 'radicalRed1500' : 'grey700'
  const dueIcon = [String(DUE_STATES.overdue), String(DUE_STATES.dueToday)].includes(String(state))
    ? 'today'
    : 'calendar'
  const dueDaysBetweenToday = dueDate ? dueDate.diff(moment(), 'days') + 1 : undefined

  return { state, dueTextColor, dueIconColor, dueIcon, dueDaysBetweenToday }
}
